import api from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'

export interface DashboardStats {
    summary: {
        products: number
        categories: number
        blog: number
        partners: number
        team: number
        contacts: { total: number; new: number }
        applications: { total: number; new: number }
    }
    recent: {
        products: any[]
        applications: any[]
        contacts: any[]
    }
    distribution: {
        categories: Array<{ name: string; value: number; type: string }>
    }
    trends: Array<{ name: string; urun: number }>
}

export const statsService = {
    getStats: async (): Promise<DashboardStats> => {
        const response = await api.get('/stats')
        return response.data
    },
}

export const useDashboardStats = () => {
    return useQuery({
        queryKey: ['dashboard-stats'],
        queryFn: statsService.getStats,
        refetchInterval: 1000 * 60 * 5, // Refetch every 5 minutes
    })
}
